import type { ComponentProps } from "@blocknote/react";
import classNames from "classnames";
import { bgStyles, borderStyles, flexStyles, overflowStyles, paddingStyles, textStyles, widthStyles } from "ui";

type Props = ComponentProps["SuggestionMenu"]["Root"];
export function Root({ children, className }: Props) {
  return (
    <div
      data-ps-bs-suggestion-menu-root
      className={classNames(
        paddingStyles.p050,
        flexStyles.vert050,
        bgStyles.neutral100,
        borderStyles.radius025,
        borderStyles.neutral300,
        textStyles.neutral600,
        overflowStyles.scroll,
        widthStyles.maxWidth2500,
        className,
      )}
    >
      {children}
    </div>
  );
}
